// Temporary fix to make queries work without full chat system
(function () {
  const debugQueryFix = window.localStorage && window.localStorage.getItem('askfelix.debugAuth') === 'true';
  const logQueryFix = (...args) => {
    if (debugQueryFix) {
      console.debug(...args);
    }
  };

  logQueryFix('Query fix loaded');

  // Override the problematic function
  if (window.dataAccessor) {
    const originalGetCurrentActiveChat = window.dataAccessor.getCurrentActiveChat;

    if (typeof originalGetCurrentActiveChat === 'function') {
      window.dataAccessor.getCurrentActiveChat = function (user) {
        return originalGetCurrentActiveChat.call(window.dataAccessor, user).then(function (chat) {
          return chat || {
            name: window.dataAccessor.currentActiveChatName || 'Default',
            id: 'default-chat',
            messages: {}
          };
        });
      };
    }

    if (typeof window.dataAccessor.getCurrentActiveChatName !== 'function') {
      window.dataAccessor.getCurrentActiveChatName = function () {
        return Promise.resolve(window.dataAccessor.currentActiveChatName || 'Default');
      };
    }
  }

  // Also ensure window.userData is properly set after login
  document.addEventListener('user-ready', function (event) {
    logQueryFix('User ready event received in query-fix');
    const detail = (event && event.detail) || window.userData;
    if (detail && detail.secret) {
      window.userData = detail;
      logQueryFix('userData set with secret:', window.userData.secret ? '***' : 'missing');
    }
  });
})();
